import {Component, Inject, Optional} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {CommissionRulesService} from '../../service/commission-rules.service';
import {MatSnackBar} from '@angular/material/snack-bar';

@Component({
    selector: 'commission-rule-delete-dialog',
    templateUrl: './commission-rule-delete-dialog.component.html',
    standalone: false
})
export class CommissionRuleDeleteDialogComponent {
    isLoading = false;

    constructor(
        @Optional() public dialogRef: MatDialogRef<CommissionRuleDeleteDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: {workflowId: number; ruleName: string},
        private commissionRulesService: CommissionRulesService,
        private _snackBar: MatSnackBar,
    ) {}

    okClick() {
        if (this.data.workflowId) {
            this.isLoading = true;
            this.commissionRulesService.deleteRule(this.data.workflowId).subscribe(() => {
                this._snackBar.open('Commission rule deleted', 'Dismiss', {
                    horizontalPosition: 'center',
                    verticalPosition: 'bottom',
                });
                this.dialogRef.close(true);
            });
        } else {
            this.dialogRef.close();
        }
    }

    onNoClick() {
        this.dialogRef.close(false);
    }
}
